import { Controller } from "@hotwired/stimulus";
import { blurFocusedPicker } from "../lib/blur_picker";

// Submits the surrounding form as soon as a select changes. Used where the
// choice is the whole decision — assigning a ticket — so a separate save button
// is one click of ceremony.
//
// Picking an autosave controller: this one for instant submit-on-change of a
// single control; auto-save for a debounced Turbo submit of a whole form with
// inline error rendering; form-auto-save for a debounced background fetch
// with a save-indicator (the survey builder pattern).
export default class extends Controller<HTMLFormElement> {
  static targets = ["select"];

  save(): void {
    // Same shape as turbo-form-submit: a focused picker would be refocused by
    // Turbo when this submit's own response replaces the region holding it.
    blurFocusedPicker();
    this.element.requestSubmit();
  }
}
